import { StyleSheet } from 'lib/paypalphrodite'
import * as media from '../../lib/styles/media-queries.js'
import { isDw2Repaint } from 'experiments/dw2Repaint'
import { BOX_BORDER_STYLES } from 'lib/styles/styles'
import { v2grey500 } from '@paypalcorp/pp-react'

const primaryTextStyle = {
  fontSize: '16px',
  lineHeight: '24px',
  color: '#2C2E2F',
}
const subTextStyle = {
  fontSize: '14px',
  lineHeight: '20px',
  color: '#687173',
}

export default StyleSheet.create({
  headerBox: {
    textAlign: 'center',
    background: 'white',
    marginBottom: 15,
    padding: isDw2Repaint() ? '1.125rem' : '20px 20px 0px 20px',
    border: '1px solid #f2f2f2',
    [media.smallAndBigger]: {
      padding: 50,
    },
    ...(isDw2Repaint() && { ...BOX_BORDER_STYLES }),
  },
  pageWrapper: {
    maxWidth: isDw2Repaint() ? media.SIZE_GREY_BACKGROUND : 500,
    margin: '30px auto',
  },
  firstTimeUserHelpInfo: {
    textAlign: 'left',
    marginBottom: '1em',
    [media.smallAndBigger]: {
      marginBottom: 0,
    },
  },
  giftBlurb: {
    margin: '20px 0 8px',
    padding: '0 2em',
    textAlign: 'left',
  },
  rtrGiftBlurb: {
    ...primaryTextStyle,
  },
  giftBlurbENSubText: {
    marginTop: 0,
    padding: '0 2em',
    textAlign: 'left',
    ...subTextStyle,
  },
  fbRedirectLink: {
    padding: '14px 114px',
    textAlign: 'center',
  },
  fbRedirect: {
    width: '100%',
    maxWidth: '380px',
    minWidth: '200px',
    marginBottom: '20px',
  },
  opinionContainer: {
    border: '2px solid #0070ba',
    padding: '15px 15px 0px 15px',
    marginTop: '40px',
    marginBottom: '10px',
    cursor: 'pointer',
    textAlign: 'left',
    [media.smallAndSmaller]: {
      marginRight: '5%',
      marginLeft: '5%',
    },
  },
  opinionHeader: {
    color: '#0070ba',
    fontWeight: 'bold',
    textAlign: 'left',
  },

  opinionParagraph: {
    marginTop: '5px',
    marginBottom: '10px',
  },
  successSubheader: {
    margin: 0,
    padding: '20px 28px',
    backgroundColor: '#f0f8ff',
    borderRadius: '10px',
    fontSize: '16px',
  },
  successMgmSubheader: {
    marginBottom: '10%',
    fontSize: '15px',
  },
  successMgmSubheaderLine: {
    display: 'block',
  },
  successHeaderENSubText: {
    margin: '0 0 38px',
    fontFamily: "'PayPal-Sans-Big', sans-serif",
    fontWeight: 400,
    ...subTextStyle,
  },
  doneButtonContainer: {
    textAlign: 'center',
    padding: '1em 1em 2em',
  },
  doneButton: {
    width: '15rem',
  },
  xsellSuccess: {
    padding: '0px',
  },
  orderNumberText: {
    display: 'inline',
    color: v2grey500,
  },
  orderNumberLink: {
    padding: '5px',
  },
})
